let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fOLlY"), load("iLLJH"), load("hDNUK")]).then(() => parcelRequire('esUj7'));